import React, { useState, useEffect } from 'react';
import { submitFormData } from '../../../pages/api';
import { useNavigate } from 'react-router-dom';
import DeleteIcon from '@mui/icons-material/Delete';

const Form_16 = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    

    // Define form fields dynamically
    const fields = [
        { label: 'Date', name: 'date', readOnly: true },
        { label: 'Rejected Module SN', name: 'rejectedModules.serialNumber' },
        { label: 'Defect Name', name: 'rejectedModules.defectName' },
    ];

    // Initialize form data from sessionStorage or default values
    const [formData, setFormData] = useState(() => {
        const savedData = sessionStorage.getItem('RecordRejectedModuleF16formData');
        return savedData
            ? JSON.parse(savedData)
            : fields.reduce((acc, field) => {
                  const fieldName = field.name.split('.');
                  if (fieldName.length > 1) {
                      if (!acc[fieldName[0]]) acc[fieldName[0]] = [{ [fieldName[1]]: '' }];
                  } else {
                      acc[field.name] = '';
                  }
                  return acc;
              }, {});
    });

    // const [errors, setErrors] = useState({});
    // const [isLoading, setIsLoading] = useState(false);
    // const [showWarning, setShowWarning] = useState(false);

    // Prefill date from sessionStorage
    useEffect(() => {
        const inspectionDate = sessionStorage.getItem('inspectionDate');
        if (inspectionDate) {
            setFormData((prevData) => ({
                ...prevData,
                date: inspectionDate,
            }));
        }
    }, []);

    // Fetch data from inspectionData only if formData is empty
    useEffect(() => {
        const isFormDataEmpty = Object.values(formData).every((value) => {
            if (Array.isArray(value)) {
                return value.every((item) => Object.values(item).every((val) => val === '' || val === null || val === undefined));
            }
            return value === '' || value === null || value === undefined;
        });

        if (isFormDataEmpty) {
            const inspectionData = sessionStorage.getItem('inspectionData');
            if (inspectionData) {
                try {
                    const parsedInspectionData = JSON.parse(inspectionData);
                    setFormData((prevData) => ({
                        ...prevData,
                        date: parsedInspectionData.RecordRejectedModuleDuringInspection?.date || prevData.date,
                        rejectedModules: parsedInspectionData.RecordRejectedModuleDuringInspection?.rejectedModules || prevData.rejectedModules,
                    }));
                } catch (error) {
                    console.error('Error parsing inspectionData:', error);
                }
            }
        }
    }, []);

    // Persist form data in sessionStorage whenever formData changes
    useEffect(() => {
        sessionStorage.setItem('RecordRejectedModuleF16formData', JSON.stringify(formData));
    }, [formData]);

    // Save form data to sessionStorage on every change
    const saveToSessionStorage = (data) => {
        sessionStorage.setItem('RecordRejectedModuleF16formData', JSON.stringify(data));
    };

    const handleChange = (e, index, field) => {
        const { value } = e.target;
        setFormData((prevData) => {
            const newModules = [...prevData.rejectedModules];
            newModules[index][field] = value;
            const updatedData = { ...prevData, rejectedModules: newModules, isSaved: false };
            saveToSessionStorage(updatedData); // Save to sessionStorage
            return updatedData;
        });
    };

    const handleAddRow = () => {
        setFormData((prevData) => {
            const updatedData = {
                ...prevData,
                rejectedModules: [...prevData.rejectedModules, { serialNumber: '', defectName: '' }],
                isSaved: false,
            };
            saveToSessionStorage(updatedData); // Save to sessionStorage
            return updatedData;
        });
    };

    const handleDeleteRow = (index) => {
        setFormData((prevData) => {
            const newModules = prevData.rejectedModules.filter((_, i) => i !== index);
            const updatedData = { ...prevData, rejectedModules: newModules, isSaved: false };
            saveToSessionStorage(updatedData); // Save to sessionStorage
            return updatedData;
        });
    };

    const handleDateChange = (e) => {
        const updatedData = { ...formData, date: e.target.value, isSaved: false };
        setFormData(updatedData);
        saveToSessionStorage(updatedData); // Save to sessionStorage
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        const projectId = localStorage.getItem('selectedProject');
        const inspectionDate = sessionStorage.getItem('inspectionDate');
        const inspectionShift = sessionStorage.getItem('inspectionShift');
        const inspectorName = sessionStorage.getItem('username');
        const inspectionSupplier = sessionStorage.getItem('inspectionSupplier');
        const RecordRejectedModuleDuringInspection = { ...formData };

        const payload = {
            projectId,
            inspectionSupplier,
            inspectionDate,
            inspectionShift,
            inspectorName,
            status: 'completed',
            RecordRejectedModuleDuringInspection,
        };

        try {
            const response = await submitFormData(payload);
            alert('Form submitted successfully!');
        } catch (error) {
            console.error('Form submission error:', error);
            alert('Form submission error!');
        } finally {
            setIsLoading(false);
        }
    };

    const handleNavigate = (path) => {
        navigate(path)
    };

    // const handleConfirmNavigation = (path) => {
    //     navigate(path);
    // };

    return (
        <div className="bg-white p-6 rounded-lg shadow-lg space-y-4">
            <h2 className="text-xl font-bold text-center">Record of Rejected Module During Inspection</h2>

            <div className="w-72">
                <label className="block font-semibold mb-1">Date</label>
                <input
                    type="date"
                    name="date"
                    value={formData.date}
                    onChange={handleDateChange}
                    className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                    readOnly
                />
            </div>

            {formData.rejectedModules.map((module, index) => (
                <div key={index} className="grid grid-cols-3 gap-4 items-center">
                    <div>
                        <label className="block font-semibold mb-1">Rejected Module SN</label>
                        <input
                            type="text"
                            value={module.serialNumber}
                            onChange={(e) => handleChange(e, index, 'serialNumber')}
                            placeholder="Serial Number"
                            className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                        />
                    </div>
                    <div>
                        <label className="block font-semibold mb-1">Defect Name</label>
                        <input
                            type="text"
                            value={module.defectName}
                            onChange={(e) => handleChange(e, index, 'defectName')}
                            placeholder="Defect Name"
                            className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                        />
                    </div>
                    <DeleteIcon
                        onClick={() => handleDeleteRow(index)}
                        className="text-gray-700 cursor-pointer hover:text-gray-500 transition-colors mt-6"
                        style={{ fontSize: 28 }}
                    />
                </div>
            ))}

            <button
                type="button"
                onClick={handleAddRow}
                className="bg-gray-600 ml-0 text-white px-4 py-2 rounded mt-4 hover:bg-gray-500 transition-colors"
            >
                Add Row +
            </button>

            <div className="flex justify-between mt-4">
                <button
                    type="button"
                    onClick={() => handleNavigate('/inspections/section2/form15')}
                    className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                >
                    Previous
                </button>
                <button
                    type="button"
                    disabled={isLoading}
                    onClick={handleSubmit}
                    className="px-4 py-2 bg-[#424752] text-white rounded hover:bg-gray-500"
                >
                    {isLoading ? 'Submitting...' : 'Submit'}
                </button>
                <button
                    type="button"
                    onClick={() => handleNavigate('/inspections/section2/form17')}
                    className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                >
                    Next
                </button>
            </div>
        </div>
    );
};

export default Form_16;
